var moment = require('moment')

var dateTimeFormats = [
  'DD/MM/YYYY',
  'DD/MMM/YYYY',
  'DD/MM/YYYY HH:mm:ss',
  'DD/MM/YYYY h:mm:ss',
  'DD/MM/YYYY hh:mm:ss a',
  'DD/MM/YYYY hh:mm:ss A',
  'DD/MM/YYYY h:mm:ss a',
  'DD/MM/YYYY h:mm:ss A',
  'DD/MMM/YYYY HH:mm:ss',
  'DD/MMM/YYYY h:mm:ss',
  'DD/MMM/YYYY hh:mm:ss a',
  'DD/MMM/YYYY hh:mm:ss A',
  'DD/MMM/YYYY h:mm:ss a',
  'DD/MMM/YYYY h:mm:ss A'
]

exports.toJsDate = function toJsDate (value) {
  if (!value) {
    return value
  }

  if (typeof value.toDate === 'function') {
    return value.toDate()
  }

  if (value.seconds) {
    return new Date(value.seconds * 1000)
  }

  return value
}

exports.formatDate = function formatDate (value) {
  return moment(exports.toJsDate(value)).format('DD/MMM/YYYY')
}

exports.formatDateTime = function formatDateTime (value) {
  return moment(exports.toJsDate(value)).format('DD/MMM/YYYY hh:mm:ss a')
}

exports.parseDateTime = function parseDateTime (value) {
  return moment(exports.toJsDate(value), dateTimeFormats, true)
}



// WEBPACK FOOTER //
// ./src/store/dateutils.js